import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { BaseCssProperties, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { ConfigService } from '../config-service/config-service.service';

@Injectable({
  providedIn: 'root',
})
export class StyleServiceService {
  constructor(private configService: ConfigService) {}

  generateStyles(attri: UiZoneWidgetAttributeConfig) {
    const contentStyle = this.configService.getSpecificBaseCssStyle(attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
    ]);
    const colorTextAlignStyle = this.configService.getSpecificBaseCssStyle(attri, [
      BaseCssProperties.COLOR,
      BaseCssProperties.TEXTALIGN,
    ]);
    const colorStyle = this.configService.getSpecificBaseCssStyle(attri, [BaseCssProperties.COLOR]);

    const backgroundStyle = this.configService.getSpecificBaseCssStyle(attri, [
      BaseCssProperties.BACKGROUND_COLOR,
    ]);

    const borderStyle = this.configService.getSpecificBaseCssStyle(attri, [BaseCssProperties.BORDER]);

    const inputBackground = this.configService.getSpecificBaseCssStyle(attri, [
      BaseCssProperties.TEXT_INPUT_BG_COLOR,
    ]);

    const colorTextAlignFontStyle = this.configService.getSpecificBaseCssStyle(attri, [
      BaseCssProperties.COLOR,
      BaseCssProperties.TEXTALIGN,
      BaseCssProperties.FONT_SIZE,
      BaseCssProperties.TEXT_FONT_STYLE,
    ]);

    const baseWidgetStyle = this.configService.getSpecificBaseCssStyle(attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      BaseCssProperties.BORDER,
      BaseCssProperties.BOX_SHADOW,
    ]);
    return {
      contentStyle,
      colorTextAlignStyle,
      colorStyle,
      borderStyle,
      colorTextAlignFontStyle,
      baseWidgetStyle,
      backgroundStyle,
      inputBackground,
    };
  }

  parseRouteParams(paramMap: ParamMap) {
    const zoneUrlName = paramMap.get('zone');
    const pageUrlName =
      (paramMap.get('modal-page') ? paramMap.get('modal-page') : paramMap.get('page')) ?? '';
    const roleName = paramMap.get('role') ?? '';
    const subscription = paramMap.get('subscription') ?? '';
    const onboardingOrgId = paramMap.get('onboardingOrgId') ?? undefined;

    if (zoneUrlName === null || pageUrlName === null) {
      throw Error('No zone or page specified via path or input');
    }

    return {
      zone: zoneUrlName,
      pageUrl: pageUrlName,
      roleName,
      subscription,
      onboardingOrgId,
    };
  }
}
